import React from 'react';

import classNames from 'classnames';

interface IFixedFooterProps {
  children: React.ReactChild;
  className?: string;
}

const FixedFooter = ({ children, className, ...props }: IFixedFooterProps) => {
  return (
    <div
      id="fixed-footer"
      className={classNames('fixed-bottom d-flex bg-white p-2 shadow-sm ', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default FixedFooter;
